<cm-topbar title="Promocast"></cm-topbar>

<div class="d-flex justify-content-center mt-5" *ngIf="principal.publisher.promocastEnrolled != true">
  <img src="assets/images/promocast_logo_black.png" alt="consumable logo" width="270"/>
</div>

<div class="promocast-content" *ngIf="principal.publisher.promocastEnrolled != true">

  <div class="row row-cols-1 row-cols-md-3 g-4" >
    <div class="col promo-col">
      <div class="mat-step-content cm-card promo-card">
        <div class="row">
          <div class="col-12 col-md">
            <h4 class="mat-step-content-title">
              What is Promocast?
            </h4>
            <div class="mat-step-content-body">

              <p>
                Promocast is the newest way to promote your podcast for free to 100M+ MAUs across web, app, CTV and
                DOOH. We add your podcast trailers to our promotional rotation across the US, driving new subscriptions
                for you.
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col promo-col">
      <div class="mat-step-content cm-card promo-card">
        <div class="row">
          <div class="col-12 col-md">
            <h4 class="mat-step-content-title">
              Benefits
            </h4>
            <div class="mat-step-content-body">
              <ul>
                <li>Free promotion of your podcast, at scale</li>
                <li>Drive new downloads and subscriptions</li>
                <li>Easy integration, just add your podcast clips</li>
                <li>Receive statistics about your podcast clips: times played, hours played, clicks and scans</li>
              </ul>

            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col promo-col">
      <div class="mat-step-content cm-card promo-card">
        <div class="row">
          <div class="col-12 col-md">
            <h4 class="mat-step-content-title">
              How it works
            </h4>
            <div class="mat-step-content-body">
              <ul>
                <li>You enroll in Promocast</li>
                <li>You add your podcast clips</li>
                <li>We promote your podcast clips</li>
                <li>You get new podcast subscriptions for free</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>

<div class="d-flex justify-content-center promocast-enroll" *ngIf="principal.publisher.promocastEnrolled != true">
  <button mat-raised-button color="primary" class="large" (click)="enroll()">Enroll</button>
</div>

<div class="container-fluid promo-rss-table" *ngIf="principal.publisher.promocastEnrolled == true">
  <div class="row">
    <div class="col">

      <div class="cm-card">
        <div class="cm-card-header">
          <h4 class="cm-card-title">
            <div class="wrapper">
              <div class="title"><h4 class="title-text">RSS Feeds</h4></div>
              <div class="sub-title"><h4 class="sub-title-text">Your collections of 15 sec clips to be promoted through Promocast</h4></div>
            </div>
          </h4>

          <div class="cm-card-controls">
            <button mat-mini-fab color="primary" matTooltip="Add RSS Feed" aria-label="Add RSS Feed"
                    (click)="addRssFeedUrl()"
                    class="ml-3 d-none d-md-inline-block mat-toolbar-page-action">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="cm-card-content">
          <div class="card-message" [hidden]="!rssFeedLoading">
            <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
          </div>

          <div class="card-message"
               [hidden]="rssFeedLoading || (rssFeedsDataSource.data && rssFeedsDataSource.data.length && rssFeedsDataSource.filteredData.length)">
            No data available
          </div>

          <!--TABLE-->
          <div class="table-scroll-wrapper" [hidden]="rssFeedLoading || !rssFeedsDataSource.data || !rssFeedsDataSource.filteredData.length">
            <mat-table id="users-table" #table [dataSource]="rssFeedsDataSource" matSort matSortActive="name" matSortDirection="asc">



              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Name:</span>
                  {{element.name}}
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="url">
                <mat-header-cell *matHeaderCellDef mat-sort-header>URL</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">URL:</span>
                  <a target="_blank" [href]="element.url"><mat-icon>open_in_new</mat-icon></a>
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="itemPubDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Item Pub Date</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Item Pub Date:</span>
                  {{element.itemPubDate}}
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Status</span>
                  <cm-rss-status-circle [rssFeed]="element">
                    {{element.enabled ? 'Enabled' : 'Disabled' }}
                  </cm-rss-status-circle>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="enabled">
                <mat-header-cell *matHeaderCellDef class="d-flex justify-content-center align-items-center"></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Status</span>
                  <label class="toggle" for="rssToggle">
                    <input class="toggle__input" name="" type="checkbox" id="rssToggle" [checked]="element.enabled" (change)="updateFeedEnabled(element, $event)">
                    <div class="toggle__fill"></div>
                  </label>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="d-flex justify-content-center align-items-center">
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                          class="d-flex justify-content-start align-items-center justify-content-center">
                  <button mat-icon-button color="primary" disableRipple="true"
                          [matMenuTriggerFor]="menu" matTooltip="Actions">
                    <i class="far fa-ellipsis-v"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item color="warn"
                            (click)="deleteRssFeed(element)">
                      <i class="far fa-trash-alt"></i>
                      <span>Delete</span>
                    </button>
                    <button mat-menu-item
                            (click)="updateRssFeed(element)">
                      <i class="far fa-edit"></i>
                      <span>Edit</span>

                    </button>
                  </mat-menu>

                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="rssFeedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: rssFeedColumns"></mat-row>
            </mat-table>
          </div>

        </div>
        <div class="cm-card-footer" [hidden]="rssFeedLoading || !podcastClipsDataSource.data || !podcastClipsDataSource.filteredData.length">

        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid promo-rss-table" *ngIf="principal.publisher.promocastEnrolled == true">
  <div class="row">
    <div class="col">

      <div class="cm-card">
        <div class="cm-card-header">
          <h4 class="cm-card-title">
            <div class="wrapper">
              <div class="title"><h4 class="title-text">Podcast Clips</h4></div>
              <div class="sub-title"><h4 class="sub-title-text">Manually upload 15 sec clips that will be promoted through Promocast</h4></div>
            </div>
          </h4>
          <div class="cm-card-controls">
            <button mat-mini-fab color="primary" matTooltip="Add Podcast Clip" aria-label="Add Podcast Clip"
                    (click)="addPodcastClip()"
                    class="ml-3 d-none d-md-inline-block mat-toolbar-page-action">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="cm-card-content">
          <div class="card-message" [hidden]="!podcastClipsLoading">
            <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
          </div>

          <div class="card-message"
               [hidden]="podcastClipsLoading || (podcastClipsDataSource.data && podcastClipsDataSource.data.length && podcastClipsDataSource.filteredData.length)">
            No data available
          </div>

          <!--TABLE-->
          <div class="table-scroll-wrapper" [hidden]="podcastClipsLoading || !podcastClipsDataSource.data || !podcastClipsDataSource.filteredData.length">
            <mat-table id="users-table" #table [dataSource]="podcastClipsDataSource" matSort matSortActive="name" matSortDirection="asc">

              <ng-container matColumnDef="seriesName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Series Name</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Clip Name:</span>
                  {{element.seriesName}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="episodeName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Episode Name</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Clip Name:</span>
                  {{element.episodeName}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="itemDuration">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Duration</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Duration:</span>
                  {{element.itemDurationSec * 1000 | date:'mm:ss'}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="audio">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Audio</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <audio controls><source [src]="element.audioUrl" type="audio/mpeg" /></audio>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="clickThroughUrl">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Click Through URL</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">URL:</span>
                  {{element.clickThroughUrl}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="channelLanguage">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Language</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Channel Language:</span>
                  {{languageCodes.get(element.channelLanguage)}}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="channelImage">
                <th mat-header-cell *matHeaderCellDef>Image</th>
                <td mat-cell *matCellDef="let element"> <img style="width: 50px" [src]="element.imageUrl" /> </td>
              </ng-container>


              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Status</span>
                  <cm-rss-status-circle [rssFeed]="element">
                    {{element.enabled ? 'Enabled' : 'Disabled' }}
                  </cm-rss-status-circle>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="enabled">
                <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Status</span>
                  <label class="toggle" for="clipToggle">
                    <input class="toggle__input" name="" type="checkbox" id="clipToggle" [checked]="element.enabled" (change)="update(element, $event)">
                    <div class="toggle__fill"></div>
                  </label>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="d-flex justify-content-center align-items-center">
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                          class="d-flex justify-content-start align-items-center justify-content-center">
                  <button mat-icon-button color="primary" disableRipple="true"
                          [matMenuTriggerFor]="menu" matTooltip="Actions">
                    <i class="far fa-ellipsis-v"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item color="warn"
                            (click)="deletePodcastClip(element)">
                      <i class="far fa-trash-alt"></i>
                      <span>Delete</span>
                    </button>
                    <button mat-menu-item
                            (click)="updatePodcastClip(element)">
                      <i class="far fa-edit"></i>
                      <span>Edit</span>

                    </button>
                  </mat-menu>

                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="podcastClipColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: podcastClipColumns"></mat-row>
            </mat-table>
          </div>

        </div>
        <div class="cm-card-footer" [hidden]="rssFeedLoading || !podcastClipsDataSource.data || !podcastClipsDataSource.filteredData.length">

        </div>
      </div>
    </div>
  </div>
</div>
